import {bindable, customElement, inject,} from "aurelia-framework";
import {AbstractCell} from "./abstract-cell";
import {ColumnLoader} from "../../object-display/column-loader";

@customElement('sio-cell-table')
@inject(ColumnLoader)
export class Table extends AbstractCell {

    @bindable column;
    @bindable item;

    constructor(columnLoader) {
        super();

        this.columnLoader = columnLoader;
    }

    async bind() {
        this.value = this.getValue();
        // noinspection JSUnresolvedVariable
        this.options = {...this._defaultOptions, ...this.column?.options}

        this.columns = await this.columnLoader.loadColumns(
            {modelId: this.column?.options?.modelId},
            (this.column?.options?.columns ?? []).map((e) => e.property)
        );
    }

    async itemChanged() {
        await this.bind(this.bindingContext);
    }

    getColumnClass(column) {
        if (column.type === 'money' || column.type === 'number') {
            return 'tw-text-right';
        } else {
            return '';
        }
    }
}
